import { Component, Input } from '@angular/core';
import { MaintenanceBannerParams } from '../../types/maintenance-banner.model';

@Component({
  selector: 'claims-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss'],
})
export class MaintenanceBannerComponent {
  @Input() params: MaintenanceBannerParams;

  showBanner = true;

  closeBanner() {
    this.showBanner = false;
  }
}
